import EuRailFareConditionsModal from './eurail-fare-conditions-modal-component';
import EuRailFareConditionsModalService from './eurail-fare-conditions-modal-service';

const MODULE_NAME = 'app.eurail.fare-conditions-modal';
const module = angular.module(MODULE_NAME, [])
    .directive('ktEuRailFareConditionsModal', EuRailFareConditionsModal)
    .service('euRailFareConditionsModalService', EuRailFareConditionsModalService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/ukrail/eurail-fare-conditions-modal/eurail-fare-conditions-modal-module.js